module.exports = __webpack_public_path__ + "media/images/logo-fec24cc0be99520028931c97cea2d2e3.png";